module.exports = __webpack_public_path__ + "static/media/sand-bg.dbaf856e.jpg";